// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Container imports
const ContentProfileLayout = require('./component-dumb')
const smsModalActions = require('client-v2/into-landing/containers/sms-modal/actions')
const deferDispatch = require('client-v2/common/state/dispatch')

function mapStateToProps(state) {
  const {
    // Flags
    isShareReferral,
    // Values
    embedUrl,
    likers,
    referredBy,
    related,
    title,
    thumbnail,
    url
  } = state.articleProfile
  return {
    // Flags
    isDesktop: state.env.browser.has('isDesktop'),
    isRedditVideo: getIsRedditVideo(state),
    isShareReferral,
    // Values
    baseUrl: state.env.baseUrl,
    iosDeeplinkHref: state.env.deeplinkUrls.get('ios'),
    embedUrl,
    iconId: getIconId(state),
    likers: (likers.size > 0 ? getModifiedLikers(state) : null),
    provider: getProvider(state),
    referredBy,
    related,
    title,
    thumbnail,
    url
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)

  function onLikerClick() {
    return async function () {
      await businessEvents.trackSegment('into-liker-click')
    }
  }

  return {
    showSMSModal: dispatchAction(smsModalActions.show),
    onClick: onLikerClick()
  }
}

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ContentProfileLayout
)

module.exports = SmartComponent

const getProvider = createSelector(
  state => state.articleProfile.meta,
  meta => {
    const provider = meta.provider.toJS()
    provider.showStreamTitle = provider.id.toLowerCase() !== provider.streamTitle.toLowerCase()
    return provider
  }
)

const getIsRedditVideo = createSelector(
  getProvider,
  state => state.articleProfile.meta,
  (provider, meta) => provider.id === 'reddit' && (meta.media.find(mediaObject => mediaObject.has('mp4_url')) !== undefined)
)

const getIconId = createSelector(
  state => state.articleProfile.isShareReferral,
  isShared => isShared ? 'share-send' : 'heart'
)

const getModifiedLikers = createSelector(
  state => state.articleProfile.likers,
  state => state.articleProfile.referredBy,
  (likers, referringUser) => {
    const filteredLikers = referringUser
      ? likers.filter(liker => liker.user_id !== referringUser.user_id)
      : likers
    return filteredLikers.map(liker => {
      const likeCount = liker.meta.likesCount && liker.meta.likesCount.toLocaleString('en-US')
      liker.likeText = likeCount === 1 ? `${likeCount} Like` : `${likeCount} Likes`
      return liker
    })
  }
)
